import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";

const CONTENT_ID_COUNT = 1;
export const CardComparisonBenefitsTitleEditorial = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (!model || items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [benefitsTitle] = React.useMemo(() => items.map((item) => decorateEditorialHtml(item.text)), []);

  return (
    <div className="xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkText size={400} weight="bold">
        <div dangerouslySetInnerHTML={benefitsTitle} className="all-b-padding-six" />
      </UitkText>
    </div>
  );
};

export default CardComparisonBenefitsTitleEditorial;
